<app-side-top-bar [navigationItems]="navigationItems">
  <main class="patient-ai-analysis-page">
    <div class="patient-name">
      <h2>{{ selectedPatient.first_name }} {{ selectedPatient.last_name }}</h2>
    </div>
    <button type="button" class="navigate-ai-chip" (click)="navigateBack()">
      <mat-icon>arrow_back</mat-icon>
      <span>Analisi AI</span>
    </button>
    @if (isMobile) {
      <div>
        <span>Gira il dispositivo per visualizzare i dati</span>
      </div>
    }
    @if (!isMobile) {
      <mat-card class="ai-analysis-card">
        <mat-card-content class="content-wrapper">
          <app-ai-disclaimer variant="trigger"></app-ai-disclaimer>
          <div class="sections-container">
            <app-patient-overview
              [patient]="selectedPatient"
            ></app-patient-overview>
            <div class="section-divider"></div>
            <app-appointment-analysis
              [patient]="selectedPatient"
            ></app-appointment-analysis>
          </div>
        </mat-card-content>
      </mat-card>
    }
  </main>
</app-side-top-bar>
